import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { TraceProvider } from "./context/TraceContext";
import { AppProvider } from "./context/AppContext";
import { FilterProvider } from "./context/FilterContext";
import { ChecklistProvider } from "./context/ChecklistContext";
import { ReportExportProvider } from "./context/ReportExportContext";
import { QualityEventsProvider } from "./context/QualityEventsContext";
import Shell from "./components/layout/Shell";
import Dashboard from "./pages/Dashboard";
import TasksPage from "./pages/TasksPage";
import IPadModeExecution from "./pages/iPadModeExecution";
import ChecklistsPage from "./pages/ChecklistsPage";
import RequirementsPage from "./pages/RequirementsPage";
import DeviationsPage from "./pages/DeviationsPage";
import CAPAPage from "./pages/CAPAPage";
import ChangeControlPage from "./pages/ChangeControlPage";
import AuditsPage from "./pages/AuditsPage";
import AssetsPage from "./pages/AssetsPage";
import MaterialsPage from "./pages/MaterialsPage";
import DocumentsPage from "./pages/DocumentsPage";
import PQRPage from "./pages/PQRPage";
import AuditPacksPage from "./pages/AuditPacksPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import AdminPage from "./pages/AdminPage";
import AccessRestricted from "./pages/AccessRestricted";

function App() {
  return (
    <TraceProvider>
      <AppProvider>
        <FilterProvider>
          <QualityEventsProvider>
            <ChecklistProvider>
              <ReportExportProvider>
                <BrowserRouter>
            <Toaster 
              position="top-right" 
              toastOptions={{
                style: {
                  background: '#ffffff',
                  border: '1px solid #e2e8f0',
                  color: '#0f172a',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                },
              }}
            />
            <Routes>
              <Route element={<Shell />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/tasks" element={<TasksPage />} />
                <Route path="/tasks/:taskId" element={<TasksPage />} />
                <Route path="/tasks/:taskId/execute" element={<IPadModeExecution />} />
                <Route path="/checklists" element={<ChecklistsPage />} />
                <Route path="/checklists/builder" element={<ChecklistsPage />} />
                <Route path="/checklists/library" element={<ChecklistsPage />} />
                <Route path="/checklists/executions" element={<ChecklistsPage />} />
                <Route path="/requirements" element={<RequirementsPage />} />
                <Route path="/deviations" element={<DeviationsPage />} />
                <Route path="/deviations/:deviationId" element={<DeviationsPage />} />
                <Route path="/capa" element={<CAPAPage />} />
                <Route path="/capa/:capaId" element={<CAPAPage />} />
                <Route path="/change-control" element={<ChangeControlPage />} />
                <Route path="/change-control/:ccId" element={<ChangeControlPage />} />
                <Route path="/complaints" element={<DeviationsPage />} />
                <Route path="/audits" element={<AuditsPage />} />
                <Route path="/audits/self-inspections" element={<AuditsPage />} />
                <Route path="/audits/supplier" element={<AuditsPage />} />
                <Route path="/assets" element={<AssetsPage />} />
                <Route path="/materials" element={<MaterialsPage />} />
                <Route path="/documents" element={<DocumentsPage />} />
                <Route path="/pqr" element={<PQRPage />} />
                <Route path="/audit-packs" element={<AuditPacksPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/access-restricted" element={<AccessRestricted />} />
              </Route>
            </Routes>
                </BrowserRouter>
              </ReportExportProvider>
            </ChecklistProvider>
          </QualityEventsProvider>
        </FilterProvider>
      </AppProvider>
    </TraceProvider>
  );
}

export default App;
